import { render } from "./ToolboxItemCard.vue?vue&type=template&id=24022c54&scoped=true"
import script from "./ToolboxItemCard.vue?vue&type=script&lang=js"
export * from "./ToolboxItemCard.vue?vue&type=script&lang=js"

import "./ToolboxItemCard.vue?vue&type=style&index=0&id=24022c54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24022c54"]])

export default __exports__